export enum DateFormats {
  MM_DD_YYYY = "MM/DD/YYYY",
  MM_DD_YYYY_h_mm_a = "MM/DD/YYYY h:mm a",
  MM_DD_YYYY_hh_mm_ss_a = "MM/DD/YYYY hh:mm:ss a",
  MM_DD_YYYY_comma_hh_mm_ss_a = "MM/DD/YYYY, hh:mm:ss a",
  MM_DD_YYYY_comma_hh_mm_a = "MM/DD/YYYY, hh:mm a",
  TIME_AM_PM = "hh:mm a",
  YYYY_MM_DD = "YYYY-MM-DD",
  YYYYMMDD = "YYYYMMDD",
  TIME_HH_MM_SS = "hh:mm:ss",
}
export const ValidYear = 1900;

const dateOfBirth = "dateOfBirth";
const startOfCareDate = "startOfCareDate";
const dateTimeRequestReceived = "dateTimeRequestReceived";
const requestDateTime = "requestDateTime";
const createdOn = "createdOn";
const requestedDateTime = "requestedDateTime";
export const FieldType = {
  startOfCareDate,
  dateOfBirth,
  dateTimeRequestReceived,
  createdOn,
  requestDateTime,
  requestedDateTime,
};

export const DateFieldType = {
  startOfCareDate,
  dateOfBirth,
  dateTimeRequestReceived,
  createdOn,
  requestDateTime
};
